/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */

export enum ClassStatCategoryEnum {
  NOT_SET = 'NotSet',
  NON_STANDARD = 'NonStandard',
  NOT_SUBJECT = 'NotSubject',
  SUBJECT = 'Subject',
  INVALID = 'Invalid',
  MISSING_ENUM = 'MissingEnum',
}
